<template>
  <Spinner height="100vh" class="splashscreen-spinner">
    <template #header>
      <div class="splash-icon"></div>
    </template>
    <template #footer>
      <div class="splash-text">{{ $t('splash-text') }}</div>
    </template>
  </Spinner>
</template>

<script>
import Spinner from './Spinner.vue'

export default {
  name: 'SplashScreen',
  i18n: {
    messages: {
      en: {
        "splash-text": "Loading Application"
      }
    }
  },
  components: {
    Spinner
  }
}
</script>

<style>

.splashscreen-spinner {
    background: var(--color-slate-950, #0c0a3e);
    color: var(--color-slate-100, #f5f5f5);
    transition: background-color 0.2s ease, color 0.2s ease;

    .spinner {
      color: var(--color-slate-450, #a9badc);
    }

    .splash-icon {
      background-image: url("/img/logo-symbol.png");
      background-repeat: no-repeat;
      background-size: 57px;
      width: 57px;
      height: 57px;
      margin-bottom: 50px;
    }

    .splash-text {
      margin-top: 10px;
      font-size: 13px;
      color: var(--color-slate-350, #cfdbef);
      letter-spacing: 0.03em;
    }
}

.light-theme .splashscreen-spinner .splash-text,
.balanced-theme .splashscreen-spinner .splash-text {
  color: var(--color-slate-550, #475569);
}
</style>
